import Default from "./DefaultLayout";
import { NavStyle } from "shared/constants/AppEnums";

const Layouts: any = {
  [NavStyle.DEFAULT]: Default,
};
export default Layouts;
